import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Field, Form, Formik } from 'formik';
import ImageUploadWithPreview from '../../components/userManagement/imageUploadWithPreview';

const PersonalSettings = () => {
  const location = useLocation();
  const [userEmail, setUserEmail] = useState('user@example.com');
  const [adminId, setAdminId] = useState('Administrator');
  const [profileImage, setProfileImage] = useState(
    'https://d30y9cdsu7xlg0.cloudfront.net/png/138926-200.png'
  );
  const [formData, setFormData] = useState(location.state?.userData);
  const [errormsg, setErrorMsg] = useState({});
  const [formEdited, setFormEdited] = useState(false);
  const [imagefile, setImageFile] = useState(null);
  const [imageUploadStatus, setImageUploadStatus] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const validTypes = ['image/jpeg', 'image/png', 'image/gif'];

      // Validate file type
      if (!validTypes.includes(file.type)) {
        alert('Please upload a valid image (JPG, PNG, GIF).');
        return;
      }

      // Validate file size (5MB limit)
      if (file.size > 5 * 1024 * 1024) {
        alert('File size exceeds 5MB. Please upload a smaller image.');
        return;
      }

      // Read and update image
      const reader = new FileReader();
      reader.onload = (e) => {
        setProfileImage(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUploadImage = async (imagefile) => {
    setImageFile(imagefile);
    setFormEdited(true);
  };

  return (
    <>
      <div className="ViewLeadPageOuter">
        <div className="viewHeader">
          <h1>Settings</h1>
        </div>
        <div className="viewFormContainer">
          <div className="leftBlock"></div>
          <div className="rightBlock">
            <div className="whiteBlock">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-4">
                  <div className="settingLeftBlock">
                    <h2>Personal Settings</h2>
                    <p>
                      Profile is a set of permissions dealing with module access and operations,
                      setup customizations, and access to various apps. You can provide different
                      set of permissions to various users.
                    </p>
                    <div className="uploadImageContainer">
                      <ImageUploadWithPreview
                        uploadFile={handleUploadImage}
                        imageUploadStatus={imageUploadStatus}
                        formData={formData}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-8">
                  <div className="rightContent borderLeft cutomePanelHight">
                    <div id="personal-setting">
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, .05) ',
                        }}
                      >
                        <div className="profile-pic">
                          <div className="image-container">
                            <img
                              alt="User Pic"
                              src={profileImage}
                              id="profile-image1"
                              style={{
                                filter: 'grayscale(100%)',
                                mixBlendMode: 'multiply',
                              }}
                            />

                            <div
                              className="camera-overlay"
                              onClick={() =>
                                document.getElementById('profile-image-upload').click()
                              }
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="24"
                                height="24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="camera-icon"
                              >
                                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h4.28l1.45-2h7.54l1.45 2H21a2 2 0 0 1 2 2zM12 13a3 3 0 1 0 3 3 3 3 0 0 0-3-3z"></path>
                              </svg>
                            </div>
                          </div>
                          <input
                            id="profile-image-upload"
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                          />
                        </div>
                        <div className="account_info_container">
                          <div className="account_info">
                            <div className={formData?.email ? 'me-2' : ''}>{formData?.email}</div>
                            <div className="adminid">
                              {/* Administrator ID:  */}

                              {adminId}
                            </div>
                          </div>
                          <div className="usermail">
                            <Link className="pdright" href="#">
                              Manager
                            </Link>
                            <span className="pdright">at</span>

                            <Link className="pdright" href="#">
                              TEST
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="user_information_txt">
                      <Formik>
                        <Form>
                          <div className="row">
                            <div className="col-12 col-sm-6 col-md-6">
                              <div className="input-container">
                                <label htmlFor="email">
                                  First Name
                                  <span className="required-star">*</span>
                                </label>
                                <Field
                                  className="formik-input"
                                  required
                                  type="text"
                                  name="firstname"
                                  id="firstname"
                                  value={formData?.firstName}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-6 col-md-6">
                              <div className="input-container">
                                <label htmlFor="email">
                                  Last Name
                                  <span className="required-star">*</span>
                                </label>
                                <Field
                                  className="formik-input"
                                  required
                                  type="text"
                                  name="lastname"
                                  id="lastname"
                                  value={formData?.lastName}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-6 col-md-6">
                              <div className="input-container">
                                <label htmlFor="email">
                                  Email<span className="required-star">*</span>
                                </label>
                                <Field
                                  className="formik-input"
                                  required
                                  type="text"
                                  name="email"
                                  id="email"
                                  value={formData?.email}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-6 col-md-6">
                              <div className="input-container">
                                <label htmlFor="email">Role</label>
                                <Field
                                  className="formik-input"
                                  required
                                  type="text"
                                  name="role"
                                  id="role"
                                  value={formData?.roles[0].roleName}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-6 col-md-6">
                              <div className="input-container">
                                <label htmlFor="email">Profile</label>
                                <Field
                                  className="formik-input"
                                  required
                                  type="text"
                                  name="profile"
                                  id="profile"
                                  value={formData?.profile_name}
                                />
                              </div>
                            </div>
                          </div>
                        </Form>
                      </Formik>
                      <div className="infodetail_group" style={{ marginTop: '113px' }}>
                        <button type="button" className="btn btn-outline-primary">
                          Cancel
                        </button>
                        <button type="button" className="btn btn-primary">
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PersonalSettings;
